<template>
  <div class="availables__casas-box center-text">
    <div class="availables__casas-title filters__web">
      <div :class="changeColorCount" class="count">{{ availables.length }}</div>
      <div class="text">
        <h2>CASAS DISPONIBLE</h2>
      </div>
    </div>

    <div class="box__rangers-filters filters__web">
      <div class="box__rangers-filters-casas">
        <h2 class="center-text range__container-title">
          Filtrar Tipo de Casas
        </h2>
        <div class="u__center-flex">

          <div class="availables__casas-buttons">
            <div @click="showAllModels()" :class="fillAll" class="availables__casas-buttons-btn"></div>
            <div class="availables__casas-buttons-text">TODOS</div>
          </div>
        </div>
        <div class="u__display-inlineblock" v-for="(model, index) in setModels" :key="index">
          <div class="availables__casas-buttons">
            <div @click="activeModelClick(model), updateActiveModel()" :class="fillActive(model)"
              class="availables__casas-buttons-btn"></div>
            <div class="availables__casas-buttons-text">{{ textOption }} {{ model.type }}</div>
          </div>
        </div>
      </div>
      <div class="contents-rangers box__filters">
        <h2 class="center-text range__container-title">
          Filtrar Precios de Casas
        </h2>
        <div class="range__container-item range-price-container">
          <div class="range-numbers range-numbers-left">
            {{ formatValue(returnMinPrice) }}
          </div>
          <div class="range-buttons range-buttons-price">
            <vue-slider class="rangeprice-custom range-price-custom" :tooltip-formatter="(val) => formatValue(val)"
              v-model="rangePrice" :min="returnMinPrice" :max="returnMaxPrice" @change="updateActiveModelRange()"
              :enable-cross="false">
            </vue-slider>
          </div>
          <div class="range-numbers range-numbers-right">
            {{ formatValue(returnMaxPrice) }}
          </div>
        </div>
      </div>
    </div>
    <span class="filters__mobile filters__ref"></span>

    <div class="filters__mobile filters__content">
      <div style="justify-content:flex-end;display: flex;align-items: center;padding:10px">
        <b class="range-numbers" @click="openFilter = !openFilter"
          style="border-bottom: 2px solid black;margin-right: 5px;cursor:pointer">{{ openFilter ? `Ocultar
                    filtros`: `Mostrar filtros` }}
        </b> <i><font-awesome-icon :icon="closeIcon" style="font-size:1.5rem;margin-top: 4px;" />
        </i>
      </div>
      <div class="" v-if="openFilter">
        <div class="box__rangers-filters " style="padding-bottom: 10px;">
          <div class="box__rangers-filters-casas">
            <h2 class="center-text range__container-title">
              Filtrar Tipo de Casas
            </h2>
            <div class="u__center-flex">

              <div class="availables__casas-buttons">
                <div @click="showAllModels()" :class="fillAll" class="availables__casas-buttons-btn"></div>
                <div class="availables__casas-buttons-text">TODOS</div>
              </div>
            </div>
            <div class="u__display-inlineblock" v-for="(model, index) in setModels" :key="index">
              <div class="availables__casas-buttons">
                <div @click="activeModelClick(model), updateActiveModel()" :class="fillActive(model)"
                  class="availables__casas-buttons-btn"></div>
                <div class="availables__casas-buttons-text">{{ textOption }} {{ model.type }}</div>
              </div>
            </div>
          </div>
          <div class="contents-rangers box__filters">
            <h2 class="center-text range__container-title">
              Filtrar Precios de Casas
            </h2>
            <div class="range__container-item range-price-container">
              <div class="range-numbers range-numbers-left">
                {{ formatValue(returnMinPrice) }}
              </div>
              <div class="range-buttons range-buttons-price">
                <vue-slider class="rangeprice-custom range-price-custom" :tooltip-formatter="(val) => formatValue(val)"
                  v-model="rangePrice" :min="returnMinPrice" :max="returnMaxPrice" @change="updateActiveModelRange()"
                  :enable-cross="false">
                </vue-slider>
              </div>
              <div class="range-numbers range-numbers-right">
                {{ formatValue(returnMaxPrice) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="availables__casas-title filters__mobile">
      <div :class="changeColorCount" class="count">{{ availables.length }}</div>
      <div class="text">
        <h2>CASAS DISPONIBLE</h2>
      </div>
    </div>

  </div>
</template>
<script>
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { mapGetters, mapActions } from "vuex"
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
export default {
  props: ["existFilter", "activeModel", "desarrollo", "priceFilter"],
  components: {
    VueSlider
  },
  data() {
    return {
      closeIcon: faFilter,
      fillAll: "active__btn-casas",
      mutateModel: "",
      rangePrice: "",
      model: "",
      allM: true,
      openFilter: false
    }
  },
  computed: {
    ...mapGetters({
      filterModelos: "getStatusFilterModelos"
    }),
    setModels() {
      let personasMap = this.existFilter.map((item) => {
        return [item.type, item];
      });
      var personasMapArr = new Map(personasMap);
      return [...personasMapArr.values()];
    },
    availables() {
      return this.filterModelos.filter((i) => i.status == 2)
    },
    changeColorCount() {
      if (this.availables >= 0) {
        return 'count__unavailable'
      } else {
        return 'count__available'
      }
    },
    textOption() {
      if (this.desarrollo === 'bosques') {
        return 'MODELO'
      } else {
        return ''
      }
    },
    returnMinPrice() {
      if (this.priceFilter) {
        return Number(this.priceFilter[0]);
      } else {
        return false;
      }
    },
    returnMaxPrice() {
      if (this.priceFilter) {
        return Number(this.priceFilter[1]);
      } else {
        return false;
      }
    },

  },
  methods: {
    ...mapActions(["getFilterModelos"]),
    formatValue(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    activeModelClick(model) {
      this.model = model
    },
    updateActiveModel() {
      this.allM = false
      let model = this.model
      let typeModel;
      let arrModel;
      typeModel = model.type
      if (this.desarrollo === 'bosques') {
        let unav = this.filterModelos.filter((i) => i.available == 0)
        let avail = this.existFilter.filter(
          (i) => i.type == typeModel && i.available > 0 && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
        arrModel = unav.concat(avail)

      } else {
        let unav = this.filterModelos.filter((i) => i.available == 0 && i.reserved == 0)
        let avail = this.existFilter.filter(
          (i) => i.type == typeModel && (i.available > 0 || i.reserved > 0) && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
        arrModel = unav.concat(avail)

      }
      this.$emit('onUpdateModel', arrModel)

      this.mutateModel = model.type;
      this.fillAll = '';
    },
    updateActiveModelRange() {
      let model = this.model
      let typeModel;
      let arrModel;
      typeModel = model.type
      if (this.allM) {
        if (this.desarrollo === 'bosques') {
          let unav2 = this.filterModelos.filter((i) => i.available == 0)
          let avail2 = this.existFilter.filter(
            (i) => i.available > 0 && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
          arrModel = unav2.concat(avail2)
        } else {
          let unav2 = this.filterModelos.filter((i) => i.available == 0 && i.reserved == 0)
          let avail2 = this.existFilter.filter(
            (i) => (i.available > 0 || i.reserved > 0) && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
          arrModel = unav2.concat(avail2)
        }
        this.$emit('onUpdateModel', arrModel)
      } else {
        if (this.desarrollo === 'bosques') {
          let unav = this.filterModelos.filter((i) => i.available == 0)
          let avail = this.existFilter.filter(
            (i) => i.type == typeModel && i.available > 0 && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
          arrModel = unav.concat(avail)

        } else {
          let unav2 = this.filterModelos.filter((i) => i.available == 0 && i.reserved == 0)
          let avail2 = this.existFilter.filter(
            (i) => i.type == typeModel && (i.available > 0 || i.reserved > 0) && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
          arrModel = unav2.concat(avail2)


        }
        this.$emit('onUpdateModel', arrModel)

        this.mutateModel = model.type;
        this.fillAll = '';
      }
    },
    showAllModels() {
      this.getFilterModelos(this.existFilter)
      this.fillAll = 'active__btn-casas'
      this.mutateModel = ''
      this.allM = true
      this.rangePrice = [this.returnMinPrice, this.returnMaxPrice];

    },
    fillActive(model) {
      if (this.mutateModel === model.type) {
        return 'active__btn-casas'
      } else {
        return 'desactive__btn-casas'
      }
    },
    handleScroll() {
      if (window.matchMedia("(max-width: 1200px)")) {

        let filterMobile = document.querySelector('.filters__ref')
        if (filterMobile) {
          let contentFilter = document.querySelector('.filters__content')
          var elementPosition = filterMobile.getBoundingClientRect().top;
          if (elementPosition > 0) {
            contentFilter.classList.remove('filters__mobile-fixed');
          } else {
            contentFilter.classList.add('filters__mobile-fixed');

          }
        }

      }

    }


  },
  mounted() {
    this.rangePrice = [this.returnMinPrice, this.returnMaxPrice];
    window.addEventListener("scroll", this.handleScroll);

  },
  created() {
  },
  updated() {
  }
}
</script>
<style scoped>
.range__container-item {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding-top: 2rem;
}

.range-numbers {
  font-size: 1.4rem;
  /* min-width: 40px; */

  /* width: 25%; */
  font-weight: 700;
}

.range-buttons {
  width: 100%;
  max-width: 300px;
}

.rangeprice-custom .vue-slider-dot-handle {
  background: #152541;
}

.rangeprice-custom .vue-slider-process {
  background: #152541;
}

.rangeprice-custom .vue-slider-dot-tooltip-inner {
  background: #152541;
  border-color: #152541;
}

.range-numbers-left {
  text-align: right;
  padding-right: 15px;
}

.range-numbers-right {
  text-align: left;
  padding-left: 15px;
}

.range__container-title {
  padding-top: 2.5rem;
}

.filters__content {
  width: 100%;
}

.filters__mobile-fixed {
  position: fixed;
  top: 0;
  background-color: white;
  z-index: 3;
  left: 0;
}

@media (min-width: 1201px) {
  .range__container-title {
    font-size: 1.8rem;
  }
  .filters__mobile {
    display: none;
  }
  .box__rangers-filters {
    display: flex;
    align-items: baseline;
    justify-content: space-evenly;
  }
}

@media (max-width: 1200px) {
  .range__container-title {
    font-size: 2.3rem;
  }

  .filters__web {
    display: none;
  }

  .open-filter {
    background: white;
  }
}

.availables__casas-box {
  padding-bottom: 3rem;
}

@media(min-width:768px) {
  .availables__casas-title {
    flex: 23%;
  }

  .box__rangers-filters {
    flex: 74%
  }

  

  .box__rangers-filters .box__rangers-filters-casas {
    width: 65%;

  }

  .box__rangers-filters .contents-rangers {
    width: 40%;

  }
}

@media (max-width: 767.67px) {
  .range__container-title {
    font-size: 2rem;
  }

}
</style>